import { useEffect } from "react";
import { useSession, signOut } from "@/lib/auth-client";
import { useRoleStore } from "@/lib/store";
import { useNavigate } from "react-router-dom";
import type { Role } from "@shared/types";

/** Syncs better-auth session with Zustand store. Use at app root. */
export function useAuth() {
  const { data: session, isPending } = useSession();
  const setUser = useRoleStore((s) => s.setUser);
  const logout = useRoleStore((s) => s.logout);

  useEffect(() => {
    if (session?.user) {
      setUser(
        session.user.id,
        (session.user as any).role as Role || "Officer",
        (session.user as any).branchId || "b1"
      );
      return;
    }
    logout();
  }, [logout, session, setUser]);

  const handleLogout = async () => {
    await signOut();
    logout();
  };

  return {
    user: session?.user || null,
    session: session?.session || null,
    isLoading: isPending,
    isAuthenticated: !!session?.user,
    logout: handleLogout,
  };
}

/** Redirect to login if not authenticated */
export function useRequireAuth() {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, isLoading, navigate]);

  return { isLoading, isAuthenticated };
}
